import React, { useState } from 'react';
import Select from 'react-timezone-select';
import worldImg from "../../assets/icons/world-icn.svg"

function TimezoneSelect({selectedTimezone, setSelectedTimezone}) {
    // Set Pakistan's timezone as the default

  return (
    <div className='reactTimezone mb-7'>
    <h1 className='text-18 font-bold'>Time zone</h1>
    <img src={worldImg} className='worldImg'/>
      <Select
        value={selectedTimezone}
        onChange={(timezone) => setSelectedTimezone(timezone.value)}
      />
    </div>
  );
}

export default TimezoneSelect;
